// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1-Ek1","Label":"BuildControl_Label__1wT0X","Less":"BuildControl_Less__30h52","More":"BuildControl_More__3nn3M"};